export default __webpack_public_path__ + "static/media/404.2ea8866b.png";